// 星春大吉 - 發文分享
'use client';

import { OFFICIAL_URL } from '@/common/constant';
import { useSelector } from 'react-redux';
import { urlState } from '@/slices/urlSlice';

const LunarYearPost = () => {
    const { forumUrl } = useSelector(urlState);
    // 投稿 tagId
    const tagId = forumUrl?.includes('local') ? 283 : forumUrl?.includes('pubgame') ? 561 : 7901;

    return (
        <div className="mt-[16px] space-y-[16px]">
            {/* 投稿按鈕 */}
            <a
                href={forumUrl + `/post?tagId=${tagId}&tag=2026星春大吉圍爐排桌`}
                className="block mx-auto w-[162px] trans hover:opacity-[.7]"
            >
                <img src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'share.png'} alt="share" />
            </a>

            <img
                className="w-[90%] mx-auto"
                src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'share_title.png'}
                alt="share"
            />
        </div>
    );
};

export default LunarYearPost;
